import { render } from "./RecuperarSenha.vue?vue&type=template&id=290d0964"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__